import { useEffect, useState } from 'react';

import store from 'store';

import { useServiceRouter } from '@common/components/ServiceRouter';
import useDateQuery from '@common/helpers/useDateQuery';
import useModel from '@common/helpers/useModel';
import ClientGradeBooks, {
	IClientGradeBooksModel,
} from '@common/models/ClientGradeBook/ClientGradeBooks';

export default () => {
	const { date, dateTime, setDateTime } = useDateQuery();
	const [format, setFormat] = useState<'day' | 'week'>('day');
	const { checkService } = useServiceRouter();

	const isDayMode = format === 'day';
	const isTis = checkService('international');

	const query = {
		student_id: store.currentStudentId,
		service_id: store.services.current.id,
	};

	const gradeBooks = useModel(
		ClientGradeBooks,
		isDayMode
			? {
					period_start: dateTime.toISODate(),
					period_end: dateTime.toISODate(),
					limit: 99,
				}
			: {
					period_start: dateTime.startOf('week').toISODate(),
					period_end: dateTime
						.startOf('week')
						.plus({ days: isTis ? 6 : 5 })
						.toISODate(),
					limit: 99,
				},
		[date, isDayMode, query.service_id, store.currentStudentId],
		{
			disableFetch: true,
		},
	) as IClientGradeBooksModel;

	useEffect(() => {
		gradeBooks.fetch(query as any);
	}, [date, isDayMode, query.service_id, store.currentStudentId]);

	const onSetFormat = (format: 'day' | 'week') => {
		setFormat(format);
	};

	return { gradeBooks, setDateTime, dateTime, format, isDayMode, date, onSetFormat };
};
